export default "__VITE_ASSET__BOdVvDEs__"